<script>

export default {
    data() {
        return {
          offsetElement: null,
          offset: 0,
        };
    },
    
    props: {
      label: String,
      target: String,
      offsetElementId: String,
      classes: {
        type: Array,
        default: function(){ return []; },
      },
    },
    
    computed: {
      selectedOption: function(){
        var self = this,
            selectedOption = self.options.find((option) => {
              return option[self.valueKey] == self.value;
            });
        return (typeof selectedOption === 'undefined') ? null : selectedOption;
      },
    },
    
    watch: {

    },
    
    methods: {
      didSelectLink: function() {
        this.scrollTo(this.target, 500);
      },
      scrollTo: function (to, duration=500) {
        
        if(this.offsetElement != null) {
          this.offset = -(this.offsetElement.offsetHeight);
        }
        
        /* 
        
        Credit: https://gist.github.com/felipenmoura/650e7e1292c1e7638bcf6c9f9aeb9dd5
          
        Example:
        //  * window.scrollPageTo('#some-section', 2000);
        //  * window.scrollPageTo(document.getElementById('some-section'), 1000);
        //  * window.scrollPageTo(500); // will scroll to 500px in 500ms
       */
        
        //t = current time
        //b = start value
        //c = change in value
        //d = duration
        const easeInOutQuad = function (t, b, c, d) {
          t /= d/2;
          if (t < 1) return c/2*t*t + b;
          t--;
          return -c/2 * (t*(t-2) - 1) + b;
        };
      
        return new Promise((resolve, reject) => {
          const element = document.scrollingElement;
          const self = this;
      
          if (typeof to === 'string') {
            to = document.querySelector(to) || reject();
          }
          if (typeof to !== 'number') {
            to = to.getBoundingClientRect().top + element.scrollTop;
          }
      
          let start = element.scrollTop,
              change = to - start,
              currentTime = 0,
              increment = 20;
      
          const animateScroll = function() {
              currentTime += increment;
              let val = easeInOutQuad(currentTime, start, change, duration);
              element.scrollTop = val + self.offset;
              if(currentTime < duration) {
                  setTimeout(animateScroll, increment);
              } else {
                resolve();
              }
          };
          animateScroll();
        });
      },
    },
    
    components: {

    },
    
    created() {

    },
    
    destroyed () {

    },
      
    mounted() {
      
      if(this.offsetElementId) {
        this.offsetElement = document.getElementById(this.offsetElementId);
      }

    },
};

</script>



<style>

</style>



<template>
  
  <div class="scroll-to-link-wrapper">
    <a 
      class="scroll-to-link" :class="this.classes"
      v-on:click.prevent="didSelectLink()" 
      :href="target">{{ label }}</a>
  </div>

</template>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ScrollToLink.vue